module.exports = __webpack_public_path__ + "img/about-15.a2e5c762.png";